import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HttpError } from '@rd/types';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { PhysicalAddressApiService } from '../../services/physical-address-api/physical-address-api.service';
import {
  LoadDetailAddress,
  LoadDetailAddressFailed,
  LoadDetailAddressSuccess,
  LoadSuggestedAddresses,
  LoadSuggestedAddressesFailed,
  LoadSuggestedAddressesSuccess,
  PhysicalAddressActions,
  PhysicalAddressActionTypes,
} from '../actions/physical-address.actions';

@Injectable()
export class PhysicalAddressEffects {
  loadSuggestedAddresses$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PhysicalAddressActionTypes.LOAD_SUGGESTED_ADDRESSES),
      switchMap((action: LoadSuggestedAddresses) => {
        return this.physicalAddressApiService
          .fetchSuggestAddresses(action.payload.query)
          .pipe(
            map((data) => new LoadSuggestedAddressesSuccess(data)),
            catchError((error: HttpError) =>
              of(new LoadSuggestedAddressesFailed(error)),
            ),
          );
      }),
    ),
  );

  loadDetailAddress$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PhysicalAddressActionTypes.LOAD_DETAIL_ADDRESS),
      switchMap((action: LoadDetailAddress) => {
        return this.physicalAddressApiService
          .fetchDetailAddress(action.payload.id)
          .pipe(
            map((data) => new LoadDetailAddressSuccess(data)),
            catchError((error: HttpError) =>
              of(new LoadDetailAddressFailed(error)),
            ),
          );
      }),
    ),
  );

  constructor(
    private actions$: Actions<PhysicalAddressActions>,
    private physicalAddressApiService: PhysicalAddressApiService,
  ) {}
}
